import {
    RESTROOM_STALL_TYPE,
    RESTROOM_STATION_FACILITIES,
    RESTROOM_FACILITIES,
} from '../constants'

const SEC_PER_DAY = 86400

export default class RestroomMasterData {
    static allFacilities = RESTROOM_FACILITIES

    static stallTypeAtToiletType = (toiletType) => {
        return Object.values(RESTROOM_STALL_TYPE).find(type => type.toiletType == toiletType)
    }

    static facilitiesAtStation = (stationId) => {
        const facilityIds = RESTROOM_STATION_FACILITIES[`${stationId}`]
        return facilityIds ? facilityIds.facility_ids.map( facilityId => RESTROOM_FACILITIES[`${facilityId}`]) : undefined
    }

    static isOpenAtStation = (stationId) => {
        const rooms = RestroomMasterData.facilitiesAtStation(stationId).flatMap( facility => facility.rooms )
        const start = Math.min(...(rooms.map( room => room.opening_hours_start)))
        const end = Math.max(...(rooms.map( room => room.opening_hours_end)))

        return RestroomMasterData.isOpenNow(start, end)
    }

    static isOpenAtRoom = (room) => {
        return RestroomMasterData.isOpenNow(room.opening_hours_start, room.opening_hours_end)
    }

    static isOpenNow = (start, end) => {
        const now = new Date(Date.now())
        var nowSec = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds()
        nowSec = nowSec < start ? nowSec + SEC_PER_DAY : nowSec
        return nowSec <= end
    }

    static stallText = (type) => {
        return type ? type.text : ""
    }

    static stallIconName = (type, isFull) => {
        if (!type) {
            return ''
        }
        const status = isFull?'manshitsu':'aki'
        return `restroom_img_${type.icon_name}-${status}`
    }

    static koujichuIconName = (type) => {
        if (!type) {
            return ''
        }
        return `restroom_img_${type.icon_name}-koujichu`
    }

    static mapImageName = (facilityId, roomId) => {
        const room = RestroomMasterData.allFacilities[facilityId].rooms.find( room => room.id == roomId)
        if (!room) return undefined
        return `restroom_map_${room.map_image_name}`
    }

    static linkUrl = (lineName, stationId) => {
        return RestroomMasterData.facilitiesAtStation(stationId) ?
        `nankaiapp://launch/?func=restroom&lid=${lineName}&sid=${stationId}`
        : undefined
    }
}